"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = require("prop-types");
function Route(_ref) {
  var isShow = _ref.isShow,
    component = _ref.component;
  return isShow ? component() : null;
}
Route.propTypes = {
  isShow: _propTypes.bool.isRequired,
  component: _propTypes.func.isRequired
};
var _default = exports["default"] = Route;